module.exports = "<p>\n  transfer works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/transfer/transfer.component.html
// module id = ./src/app/transfer/transfer.component.html
// module chunks = main